import React from 'react';

import {Button, ButtonType, Colors} from '../components';
import Image from '../components/Image';
import './Mission.scss';

import {useAppStore} from '../data/AppStore';
import {buildHtmlText} from '../utilities';
import {shallow} from "zustand/shallow";
import {useNavigate} from "react-router-dom";

const Finish = () => {
    const [COMPANY, cleanSTORE] = useAppStore((state) => [state.COMPANY, state.cleanSTORE], shallow)
    const navigate = useNavigate();
    return (
        <div className='contentWrapper'>
            <div className={'finishStatement'}>
                <div className={'finishStatement-logo'}>
                    <Image src={COMPANY.settings.logo_url} fallbackSrc={null}
                           alt={`${COMPANY.name || 'loading'} logo`} className={'logo small'}/>
                </div>
                {(COMPANY.settings.thank_you_statement === 'n/a') ?
                    <p>{'Submitted Job...'}</p>
                    :
                    <p dangerouslySetInnerHTML={{__html: buildHtmlText(COMPANY.settings.thank_you_statement)}}/>
                }
            </div>
            <div className={'statementButtonWrapper'}>
                <Button
                    onClick={() => {
                        navigate('/')
                        cleanSTORE();
                    }}
                    label='Done'
                    type={ButtonType.Save}
                    colorTheme={Colors.Orange}
                />
            </div>
        </div>
    );
}

export default Finish;